/**
 * Load and process email templates (variable replacement).
 *
 * CRA does not support ?raw imports, so templates are loaded at runtime
 * from the public folder via fetch. Templates are cached after first load.
 */

const templateCache: Record<string, string> = {};

/**
 * Load an HTML template from public/email-templates/.
 */
export async function loadEmailTemplate(templateName: string): Promise<string> {
  if (templateCache[templateName]) {
    return templateCache[templateName];
  }

  const response = await fetch(`${process.env.PUBLIC_URL}/email-templates/${templateName}`);
  if (!response.ok) {
    throw new Error(`Template ${templateName} not found (${response.status})`);
  }

  const html = await response.text();
  templateCache[templateName] = html;
  return html;
}

/**
 * Replace {{key}} placeholders in template with values.
 */
export function replaceTemplateVariables(template: string, variables: Record<string, string>): string {
  let out = template;
  for (const [key, value] of Object.entries(variables)) {
    const placeholder = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
    out = out.replace(placeholder, value ?? '');
  }
  return out;
}

/**
 * Load template and replace variables.
 */
export async function processEmailTemplate(
  templateName: string,
  variables: Record<string, string>
): Promise<string> {
  const template = await loadEmailTemplate(templateName);
  return replaceTemplateVariables(template, variables);
}
